import
  React
from 'react';

import
  styled
from 'styled-components';

import
  PropTypes
from 'prop-types';

import {
  ColorSvg,
  HContainer,
  Text,
  VContainer,
  VContainerH
} from '@vodacom/web-common';

import {
  CustomColors,
  Icons
} from '../../constants';

const InfoTitle = styled(Text)`
  font-size: 14px;
  font-weight: bold;
  color:${CustomColors.Grey11};
  p {
    margin: 0;
  }
`;

const InfoText = styled(Text)`
  font-size: 14px;
  color:${CustomColors.Grey11};
  p {
    margin: 0;
  }
`;

export const InfoCard = props => {

  return (

    <VContainerH
      width={'100%'}
      margin={props.margin}>

      <VContainer
        width={'100%'}
        padding={'13px 12px 12px 19px'}
        maxWidth={'344px'}
        boxSizing={'border-box'}
        backgroundColor={CustomColors.Grey12}>

        <HContainer>

          <InfoTitle
            dangerouslySetInnerHTML={{
              __html: props.title
            }}/>

          <ColorSvg
            src={Icons.Close}
            color={CustomColors.Grey11}
            width={'13px'}
            height={'13px'}
            margin={'0 0 0 auto'}
            onClick={props.onClose}/>

        </HContainer>

          <InfoText
            fontSize={'14px'}
            color={CustomColors.Grey11}
            dangerouslySetInnerHTML={{
              __html: props.content
            }}/>
      </VContainer>

    </VContainerH>
  );
};

InfoCard.propTypes = {
  margin: PropTypes.string,
  onClose: PropTypes.func,
  showCard: PropTypes.bool,
  title: PropTypes.string,
  content: PropTypes.string
};

InfoCard.defaultProps = {
  margin: '',
  onClose: () => {},
  showCard: false,
  title: '',
  content: ''
};
